export * from './DropzoneTabs.types';
export { default as DropzoneTabs } from './DropzoneTabs';
